import React, { useState } from 'react';
import { apiPost } from '../utils/api';
import { toast } from 'react-hot-toast';

const units = [
  { value: 'celsius', label: 'Celsius (°C)' },
  { value: 'fahrenheit', label: 'Fahrenheit (°F)' },
  { value: 'kelvin', label: 'Kelvin (K)' }
];

const TemperatureConverter = () => {
  const [value, setValue] = useState('');
  const [from, setFrom] = useState('celsius');
  const [to, setTo] = useState('fahrenheit');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleConvert = async () => {
    if (!value || isNaN(parseFloat(value))) {
      toast.error('Digite um valor válido');
      return;
    }

    setLoading(true);
    setResult(null);
    try {
      const data = await apiPost('/api/converters/temperature', { value, from, to });
      setResult(data.result);
    } catch (e) {
      console.error('Erro na conversão:', e);
      toast.error('Erro na conversão. Tente novamente.');
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg mx-auto">
      <h2 className="text-2xl font-bold mb-4 text-gray-900">Conversor de Temperatura</h2>
      <p className="mb-4 text-gray-600">Converta entre Celsius, Fahrenheit e Kelvin.</p>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-4">
        <input
          type="number"
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder="Valor"
          className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <select
          value={from}
          onChange={e => setFrom(e.target.value)}
          className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          {units.map(u => <option key={u.value} value={u.value}>{u.label}</option>)}
        </select>
        <select
          value={to}
          onChange={e => setTo(e.target.value)}
          className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          {units.map(u => <option key={u.value} value={u.value}>{u.label}</option>)}
        </select>
        <button
          onClick={handleConvert}
          disabled={loading || !value}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50 w-full"
        >
          {loading ? 'Convertendo...' : 'Converter'}
        </button>
      </div>
      {result !== null && (
        <div className="mt-4 p-4 bg-gray-50 rounded-lg text-lg text-center font-mono text-gray-800">
          <div className="text-sm text-gray-600 mb-1">Resultado:</div>
          <div className="text-2xl font-bold">{result} {to === 'celsius' ? '°C' : to === 'fahrenheit' ? '°F' : 'K'}</div>
        </div>
      )}
    </div>
  );
};

export default TemperatureConverter; 